import React from 'react';
import { Provider } from 'react-redux';

import WizardContainer from './WizardContainer/WizardContainer';
import ErrorStateBoundary from './ErrorStateBoundary/ErrorStateBoundary';
import configureStore from '../store';
import PageContent from './PageContainer';

const store = configureStore();

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <PageContent>
        <ErrorStateBoundary>
          <WizardContainer />
        </ErrorStateBoundary>
      </PageContent>
    </Provider>
  );
};

export default App;
